import React from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { InfoPlate } from "fe-shared/src/components";
import { ClockIcon } from "fe-shared/src/components/Icons";
import { TRANSFER_STATUSES_CONFIG_MAP } from "../../helpers/statusesConfig";
import { TransferStatus } from "../../types";

import styles from "./TransferStatusPlate.module.scss";

interface Props {
  statusCode: TransferStatus;
  isAdjustable?: boolean;
  className?: string;
}

export const TransferStatusPlate = (props: Props) => {
  const { t } = useTranslation();
  const { statusCode, isAdjustable, className } = props;
  const variant = statusCode && TRANSFER_STATUSES_CONFIG_MAP[statusCode];

  return statusCode && variant ? (
    <div className={classnames(styles.status, className)}>
      <InfoPlate variant={variant}>
        {t(`transfers.statuses.${statusCode}`)}
      </InfoPlate>
      {isAdjustable && (
        <ClockIcon width={16} height={16} className={styles.icon} />
      )}
    </div>
  ) : (
    <div />
  );
};

export default TransferStatusPlate;
